import usePagination from "hooks/usePagination";
import { queryKeys } from "api/master";
import { useQuery } from "@tanstack/react-query";
import { MEMBER_ATTENDED_TAB_ACTIVE_KEY } from "common/common";
import { Table } from "antd";
import { cn } from "libs/classnames";
import moment from "moment";

const VisitHistory = ({ memberId, tabActiveKey }) => {
	const { pagination, setPaginationTotal, setPaginationPage } = usePagination({
		initialSortKey: "visitId",
		initialPerPage: 10,
	});
	const { data: inflowSources = [] } = useQuery({
		...queryKeys.inflowSources.listAll(),
	});

	const { data: visitHistories = [], isLoading } = useQuery({
		...queryKeys.members.listOfVisits({ memberId }),
		enabled:
			!!memberId && tabActiveKey === MEMBER_ATTENDED_TAB_ACTIVE_KEY.VISIT,
	});

	return (
		<Table
			bordered
			size="small"
			rowKey="memberVisitId"
			loading={isLoading}
			dataSource={visitHistories}
			className={cn(
				"[&_.ant-table-wrapper]:max-h-[60vh]",
				"[&_.ant-table-container]:max-h-[50vh]",
				"[&_.ant-table-container]:overflow-y-scroll",
				"[&_.ant-table-content]:overflow-x-hidden",
			)}
			columns={[
				{
					title: "来店日",
					dataIndex: "visitDate",
					key: "visitDate",
					width: "50%",
					render: (visitDate) =>
						visitDate ? moment(visitDate).format("YYYY/MM/DD HH:mm") : "ー",
				},
				{
					title: "イベント名",
					dataIndex: "inflowSourceId",
					key: "eventName",
					width: "50%",
					render: (inflowSourceId) => {
						const source = inflowSources.find(
							(s) => s.inflowSourceId === inflowSourceId,
						);
						return source ? source.qrName || "ー" : "ー";
					},
				},
			]}
			scroll={{
				x: "max-content",
			}}
			pagination={{
				current: pagination.page,
				total: pagination.total,
				onChange: setPaginationPage,
				pageSize: pagination.perPage,
			}}
		/>
	);
};

export default VisitHistory;
